import React, {useEffect} from 'react';
import {navigate} from '@reach/router';
import MasterClassIndex from './masterclass/prevent';

export default function (props) {
  useEffect(() => {
    navigate('/masterclass/prevent/' + location.search);
  }, []);
  return <MasterClassIndex />;
}
